export default "__VITE_ASSET__01781b47__"